/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import ArrowRight20 from '@andes/icons/ArrowRight20';

export const PageTile = ({ item, lang, coexistenceEnabled }) => {
  if (!item || !lang || !coexistenceEnabled) {
    return null;
  }

  const content = item.content.find(rawContent => (rawContent.lang === lang));
  const { redirect_message, redirect_label } = content || {};

  const updateBodyPageTileAttr = v => {
    try {
      document.body.dataset.pageTile = v;
    } catch {
      console.warn('Failed to update body[data-page-tile] attribute');
    }
  };

  if (!item
    || !lang
    || typeof lang !== 'string'
    || typeof item !== 'object'
    || !item.redirect_url
    || !item.content
    || !Array.isArray(item.content)
    || !item.content.length
  ) {
    return null;
  }

  if (!content || (!redirect_message && !redirect_label)) {
    return null;
  }

  const normalizeRedirectMessage = (msg) => {
    let result = msg;

    if (typeof result !== 'string' || !result) {
      return '';
    }

    if (!result.trim().endsWith('.')) {
      result = `${result}.`;
    }

    if (redirect_label) {
      result = `${result} `;
    }

    return result;
  };

  useEffect(() => {
    updateBodyPageTileAttr(true);

    return () => updateBodyPageTileAttr(false);
  }, []);

  return (
    <div className="dx-navigation-header-tile">
      <div className="dx-navigation-header-tile__content">
        <p>
          {normalizeRedirectMessage(redirect_message)}

          {redirect_label && (
            <a href={`/developers/${lang}/${item.redirect_url}`} rel="noreferrer noopener">
              {redirect_label}
            </a>
          )}
        </p>
      </div>

      {redirect_label && (
        <div className="dx-navigation-header-tile__actions">
          <a href={`/developers/${lang}/${item.redirect_url}`} rel="noreferrer noopener">
            <ArrowRight20 color="var(--andes-color-blue-500)" />
          </a>
        </div>
      )}
    </div>
  );
};
